class SiteHeader {
    constructor(el, stickyOffset = 0) {
        this.el = el;
        this.elMobile = document.querySelector('.site-header-mobile');
        this.isSticky = false;
        this.isTicking = false;
        this.stickyOffset = stickyOffset;
        this.lastScrollPosition = window.scrollY;

        if (this.el) {
            this._init();
        }
    }

    _init() {
        this._calculateHeaderHeight();

        this._bindEvents();
        this._observeResize();

        this._onScroll();
    }

    _bindEvents() {
        this.onScrollFn = this._onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollFn, { passive: true });

        // Recalculate the header-height on reisze and orientation change
        window.addEventListener('resize', () => this._calculateHeaderHeight());
        window.addEventListener('orientationchange', () => this._calculateHeaderHeight());
    }

    _observeResize() {
        const observer = new ResizeObserver(() => this._calculateHeaderHeight());
        observer.observe(this.el);

        if (this.elMobile) observer.observe(this.elMobile);
    }

    _calculateHeaderHeight() {
        if (this.el) {
            const desktopHeight = this.el.clientHeight;
            document.documentElement.style.setProperty('--header-height', `${desktopHeight}px`);
        }

        if (this.elMobile) {
            const mobileHeight = this.elMobile.clientHeight;
            document.documentElement.style.setProperty('--mobile-header-height', `${mobileHeight}px`);
        }
    }

    _onScroll() {
        this.lastScrollPosition = window.scrollY;

        if (!this.isTicking) {
            this.isTicking = true;
            window.requestAnimationFrame(() => this._update());
        }
    }

    _update() {
        this.isTicking = false;

        const shouldBeSticky = this.lastScrollPosition >= this.stickyOffset;

        if (shouldBeSticky && !this.isSticky) {
            this.el.classList.add('site-header--sticky');
            this.el.classList.add('site-header--entered');
            this.isSticky = true;
            this._calculateHeaderHeight();
        }
        else if (!shouldBeSticky && this.isSticky) {
            this.el.classList.remove('site-header--sticky', 'site-header--entered');
            this.isSticky = false;
            this._calculateHeaderHeight();
        }
    }
}

export default SiteHeader;
